import { injectable } from "inversify";
import ApiRequest from "./ApiRequest";
import IDataHelper from "./IDataHelper";
import { getDynamicConfig } from "infrastructure/configuration/configurationHelper";

const dynamicConfig = getDynamicConfig();

@injectable()
export default class DataHelper implements IDataHelper {

  getUrl(apiReuest: ApiRequest, baseUrl: string = dynamicConfig.flexiApiUrl): string {
    let url = "";
    let finalBaseUrl = apiReuest.baseUrl ? apiReuest.baseUrl : baseUrl;

    if (apiReuest.routeParams) {
      let templateUrl = apiReuest.url;

      for (const [key, value] of apiReuest.routeParams.entries()) {
        templateUrl = templateUrl.replace(`{${key}}`, value);
      }

      url = `${finalBaseUrl}/${templateUrl}`;
    } else {
      url = `${finalBaseUrl}/${apiReuest.url}`;
    }

    return url;
  }
}